app.controller("ManageGroupsController", ["$scope", "StaticData", "Lecturer", "Subject", "$uibModal", "$stateParams", "ConfirmModal", "TimetableService", "$state", "usSpinnerService",
    function ($scope, StaticData, Lecturer, Subject, $uibModal, $stateParams, ConfirmModal, TimetableService, $state, usSpinnerService) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.sessionType = $stateParams.sessionType;
        $scope.isDefined = true;
        if ($stateParams.isDefined) $scope.isDefined = $stateParams.isDefined === 'true';

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = [{name: "კვირის დღე"}].concat(days);
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.sessionTypes = [{name: "სესიის ტიპი"}].concat(types);
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                lecturer: $scope.lecturer ? $scope.lecturer._id : '',
                subject: $scope.subject ? $scope.subject._id : '',
                sessionType: $scope.sessionType,
                isDefined: $scope.isDefined
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
            if ($stateParams.lecturer) {
                Lecturer.fetchOne($stateParams.lecturer).then(function (lecturer) {
                    $scope.lecturer = lecturer;
                });
            }

            if ($stateParams.subject) {
                Subject.fetchOne($stateParams.subject).then(function (data) {
                    $scope.subject = data.subject;
                })
            }
        });

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            TimetableService.subjectList({
                page: page,
                limit: $scope.itemsPerPage,
                lecturer: $stateParams.lecturer,
                subject: $stateParams.subject,
                sessionType: $scope.sessionType,
                isDefined: $stateParams.isDefined
            }).then(function (data) {
                for(var i in data.docs) {
                    var sorted =  _.sortBy(data.docs[i].sessions, ['dayOfWeek', 'startTime']);
                    data.docs[i].sessions = sorted;
                }
                $scope.sessionGroups = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.export = function () {
            TimetableService.exportList()
        };

        $scope.addGroups = function (group) {
            $uibModal.open({
                controller: "AddGroupsWindowController",
                templateUrl: _pb + 'admin/manage/add-groups.html',
                size: "md",
                resolve: {
                    params: function () {
                        // return {group: group};
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($stateParams.page)
                }, function () {

                });
        };

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.activeList({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.changeDefined = function (value) {
            $scope.isDefined = value;
            $scope.applyFilter();
        };

        $scope.edit = function (sessionGroup, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "DefineSessionGroupController",
                templateUrl: _pb + 'admin/manage/define-session-group.html',
                size: "md",
                resolve: {
                    sessionGroup: function () {
                       return sessionGroup
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($stateParams.page)
                }, function () {
                });
        }

        $scope.remove = function (sessionGroup, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            ConfirmModal.show({
                title: "ცხრილიდან წაშლა",
                message: "გსურთ ამ ჯგუფის ცხრილიდან წაშლა?"
            }).result.then(function () {
                TimetableService.removeFromTable({ sessionGroup: sessionGroup}).then(loadPage($stateParams.page));
            });
        }
    }
]);